import { RouteComponentProps } from "@reach/router";
import { FunctionComponent, lazy } from "react";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "../shared/ErrorFallback";

interface IProps extends RouteComponentProps {
	loggedIn: boolean;
}

const LazyAnime = lazy(() => import(/* webpackChunkName: "Anime" */ "../anime/Anime"));

const HentaiPage: FunctionComponent<IProps> = (props) => {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { loggedIn, path } = props;

	if (!loggedIn) {
		return <></>;
	}

	return <ErrorBoundary FallbackComponent={ErrorFallback}>
		<LazyAnime controller="hentai" />
	</ErrorBoundary>;
};

export default HentaiPage;